import { useEffect, useRef } from 'react';
import PinField from 'react-pin-field';
import './OtpInputField.scss';

interface OtpInputFieldProps {
    length?: number;
    onComplete: (code: string) => void;
    onChange?: (code: string) => void;
    disabled?: boolean;
    autoFocus?: boolean;
    resetKey?: string | number;
}

export default function OtpInputField({
    length = 6,
    onComplete,
    onChange,
    disabled,
    autoFocus = true,
    resetKey,
}: OtpInputFieldProps) {
    const refs = useRef<(HTMLInputElement | null)[]>([]);

    useEffect(() => {
        if (resetKey === undefined) return;
        refs.current.forEach((el) => {
            if (el) el.value = '';
        });
        if (autoFocus && refs.current[0]) {
            refs.current[0].focus();
        }
    }, [resetKey, autoFocus]);

    return (
        <div className="xv-otp-input">
            <PinField
                length={length}
                inputMode="numeric"
                pattern="[0-9]"
                className="xv-otp-input__cell"
                disabled={disabled}
                autoFocus={autoFocus}
                ref={(el) => {
                    if (Array.isArray(el)) {
                        refs.current = el;
                    }
                }}
                onComplete={onComplete}
                onChange={onChange}
            />
        </div>
    );
}
